import TransferInformation from './TransferInformation.vue';

export default TransferInformation;
